import { CoolMultiCardCarouselHeaderContainer } from './styledComponents'

export default function CarouselHeader({ heading, subHeading }) {
  return (
    <CoolMultiCardCarouselHeaderContainer>
      <div className="heading">{heading}</div>
      <div className="sub-heading">{subHeading}</div>
    </CoolMultiCardCarouselHeaderContainer>
  )
}
